<template>
  <form
    id="recovery"
    @submit="recoverPw"
    action="#"
    method="post"
    novalidate="true"
  >
    <div class="message">
      <h1>{{ $t("onboard.passForgot.header") }}</h1>
      <p>{{ $t("onboard.passForgot.text") }}</p>
    </div>

    <div class="error msg">{{ errMessage }}</div>
    <label for="email" class="required">{{
      $t("onboard.passForgot.email")
    }}</label>
    <input
      id="email"
      name="email"
      v-bind:class="{ error: errEmail || invalidEmail || errMessage }"
      v-model="email"
      v-on:input="
        errEmail = false;
        invalidEmail = false;
        errMessage = null;
      "
    />
    <p class="error errorMsg" v-if="errEmail">
      {{ $t("onboard.passForgot.noEmail") }}
    </p>
    <p class="error errorMsg" v-if="invalidEmail">
      {{ $t("onboard.passForgot.invalidEmail") }}
    </p>

    <div class="center-wrapper">
      <input
        type="submit"
        class="submit"
        v-bind:value="$t('onboard.passForgot.button.send')"
      />
    </div>
  </form>
</template>

<script>
import { userService } from "@/services/user.service";
import { validEmail } from "@/utils/validEmail";

export default {
  name: "PassForgot",
  data() {
    return {
      errMessage: null,
      errEmail: false,
      invalidEmail: false,
      email: null,
    };
  },
  methods: {
    recoverPw: function (event) {
      this.errMessage = null;

      if (!this.email) {
        this.errEmail = true;
      }

      if (this.email && !validEmail(this.email)) {
        this.invalidEmail = true;
      }

      if (!this.errEmail && !this.invalidEmail) {
        userService
          .forgotPassword(this.email)
          .then(() => {
            this.$router.push("/reset");
          })
          .catch(() => {
            this.errMessage = this.$t("onboard.passForgot.errorMsg");
          });
      }

      event.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
#recovery {
  h1,
  p {
    text-align: center;
  }
  .message {
    margin-bottom: 45px;
    padding-top: 120px;
    background: url("../../assets/icons/onboard-password.png") no-repeat center
      top;
  }
  .center-wrapper {
    margin-top: 15px;
    text-align: center;
    input {
      margin: 0;
    }
  }
}

.error {
  margin-bottom: 20px;
}
.errorMsg {
  margin-top: -20px;
  text-align: start !important;
}
</style>
